import './separator.css'

export default function Separator({ text = 'OR' }) {
  return <div className="separator hc-mt-md hc-mb-md">{text}</div>
}
